import axios from "axios";
import { LocationNotFound } from "./errors/location-not-found";
export const API_KEY =
  process.env.REACT_APP_GOOGLE_API_KEY ||
  "AIzaSyAMr1Gw7bKrjmP4434fbXAyLDrP3VOPZYw";

export const GEO_CODE_API_KEY =
  process.env.REACT_APP_GOOGLE_GEOCODE_API_KEY ||
  "AIzaSyAMr1Gw7bKrjmP4434fbXAyLDrP3VOPZYw"; // Ideally should be in bckend as this key dont't have client side restrictions.

export const searchBounds = async address => {
  const { data } = await axios.get(
    "https://maps.googleapis.com/maps/api/geocode/json",
    {
      params: {
        address,
        key: GEO_CODE_API_KEY
      }
    }
  );
  if (data.results.length === 0) {
    throw new LocationNotFound(
      "Location Not Found. Try Again with another name."
    );
  }
  const { northeast, southwest } = data.results[0].geometry.viewport;
  return {
    north: northeast.lat,
    east: northeast.lng,
    south: southwest.lat,
    west: southwest.lng
  };
};
